import { SESSION_TIME_OUT_DELAY, createValueHistory } from '@datadog/browser-core';
export var VIEW_CONTEXT_TIME_OUT_DELAY = SESSION_TIME_OUT_DELAY;
export function startViewHistory(lifeCycle) {
  var viewValueHistory = createValueHistory({
    expireDelay: VIEW_CONTEXT_TIME_OUT_DELAY
  });
  lifeCycle.subscribe(1 /* LifeCycleEventType.BEFORE_VIEW_CREATED */, function (view) {
    viewValueHistory.add(buildViewHistoryEntry(view), view.startClocks.relative);
  });
  lifeCycle.subscribe(6 /* LifeCycleEventType.AFTER_VIEW_ENDED */, function (_ref) {
    var endClocks = _ref.endClocks;
    viewValueHistory.closeActive(endClocks.relative);
  });
  lifeCycle.subscribe(3 /* LifeCycleEventType.BEFORE_VIEW_UPDATED */, function (viewUpdate) {
    var currentView = viewValueHistory.find(viewUpdate.startClocks.relative);
    if (!currentView) {
      return;
    }
    if (viewUpdate.name) {
      currentView.name = viewUpdate.name;
    }
    if (viewUpdate.context) {
      currentView.context = viewUpdate.context;
    }
    currentView.sessionIsActive = viewUpdate.sessionIsActive;
  });
  lifeCycle.subscribe(10 /* LifeCycleEventType.SESSION_RENEWED */, function () {
    viewValueHistory.reset();
  });
  function buildViewHistoryEntry(view) {
    return {
      service: view.service,
      version: view.version,
      context: view.context,
      id: view.id,
      name: view.name,
      startClocks: view.startClocks
    };
  }
  return {
    findView: function findView(startTime) {
      return viewValueHistory.find(startTime);
    },
    stop: function stop() {
      viewValueHistory.stop();
    }
  };
}